/**
 * Initializes the Slick carousel for .video_block_product containers.
 * Referenced from layout/theme.liquid.
 */
(function ($) {
  $(document).ready(function () {
    if ($('div.video_block_product').length) {
      $('.video_block_product').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 479,
            settings: {
              infinite: false,
              slidesToShow: 2.3,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  });
})(jQuery);
